// import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import dynamic from 'next/dynamic';
import useWindowSize from '@components/_hooks/useWindowSize';
import useProduct from '@components/_hooks/CSRHooks/useProduct';
import { productLink } from '@components/config/helpers';
import OG from '../Reusables/OG';

const PageHead = dynamic(() => import('../Reusables/PageHead'))
const ProductLoadingSkeleton = dynamic(() => import('./ProductLoadingSkeleton'))
const BoxContainer = dynamic(() => import('../Reusables/BoxContainerV2'))
const ProductContainer = dynamic(() => import('./ProductContainer'))
// const ProductSlider2 = dynamic(() => import('./ProductSlider2'))
const ProductSchema = dynamic(() => import('../Schemas/ProductSchema'))

const ProductV2 = ({productData}) => {
    const {isMobile} = useWindowSize();

    const {
            localProductData,
            loadingProducts
        } = useProduct(productData);

        const {
            extras,
            product, 
        //   product_price,
            addon_groups, 
            long_term_product,
            price_breaks,
        //   long_term_hire_discount_rows,
            width,
            depth,
            height,
            long_term,
            measurements, 
            key_features,
            videos,
            articles,
            reviews,
            faqs,
            product_variants,
        //   frequently_bought_together,
            related_products,
            product_extra_media,
            long_desc,
        //   defaults,
            template_page_settings
        } = localProductData

    const canonical_link = process.env.brand.brand_id == 1 ? false : `${process.env.NEXT_PUBLIC_HOME_URL}/${localProductData.canonical_link}`

    
    return (
        <>
            <PageHead
                title={localProductData.product.product_meta_title}
                description={localProductData.product.product_meta_desc}
                keywords={localProductData.product.meta_keywords}
                link={canonical_link}
            />
            <OG property='title' content={localProductData.product.product_meta_title}/>
            <OG property='type' content={"product"}/>
            <OG property='url' content={`${process.env.BASE_URL}${productLink(localProductData.product.section_slug, localProductData.product.product_slug, long_term)}`}/>
            <OG property='image' content={localProductData.product.image}/>
            <OG property='description' content={localProductData.product.product_meta_desc}/>
            <OG property='site_name' content={process.env.brand.brand_name}/>

            <BoxContainer id="product_page" className={ (!isMobile && template_page_settings?.page_class_type ? template_page_settings?.page_class_type : 'pl-2 pr-2')}>
                <ProductSchema productData={localProductData}/>

                {loadingProducts.current ? (
                    <ProductLoadingSkeleton/>
                ) : (
                    <>
                        {localProductData && (
                            <>
                                <ProductContainer
                                    productData={localProductData}
                                    product_extra_media={product_extra_media}
                                    product={product}
                                    long_desc={long_desc}
                                    long_term_product={long_term_product}
                                    price_breaks={price_breaks}
                                    width={width}
                                    depth={depth}
                                    height={height}
                                    measurements={measurements}
                                    articles={articles}
                                    faqs={faqs}
                                    videos={videos}
                                    product_variants={product_variants}
                                    reviews={reviews}
                                    key_features={key_features}
                                    addon_groups={addon_groups}
                                    related_products={related_products}
                                    long_term={long_term}
                                    template_page_settings={template_page_settings}
                                />
                            </>
                        )}
                    </>
                )}
            </BoxContainer>
        </>
    )
}
export default ProductV2